export const CONFIG = {
  AIRTABLE_API: 'keyzKU5ACyGeQbbQ5'
}
